import React, { useContext } from "react";
import {
  HeaderContainer,
  HeaderContentContainer,
  White,
  EventButton,
} from "./styles";
import NavBar from "components/NavBar";
import { Link, useRoute } from "wouter";
import MainLogo from "components/MainLogo";
import { SiteConfigContext } from "contexts/SiteConfigContext";
import usePageScrolled from "hooks/usePageScrolled";

export default function Header() {
  const [isHome] = useRoute("/");
  const scrolled = usePageScrolled();
  const { eventButton } = useContext(SiteConfigContext);

  // Sólo en la home el header flota sobre el video, y sólo mientras no se
  // scrolleó: después necesita fondo sólido para leerse sobre el contenido.
  const overlay = isHome && !scrolled;

  return (
    <HeaderContainer className="no-print" floating={isHome} overlay={overlay}>
      <HeaderContentContainer>
        {!overlay && <White />}
        <Link to="/">
          <MainLogo position={overlay ? "overlay" : "header"} />
        </Link>
        {eventButton.visible && (
          <EventButton
            href={eventButton.url}
            target="_blank"
            rel="noopener noreferrer"
            overlay={overlay}
          >
            {eventButton.label}
          </EventButton>
        )}
        <NavBar overlay={overlay} />
      </HeaderContentContainer>
    </HeaderContainer>
  );
}
